import gql from 'graphql-tag'

export default gql`
  query getSharedFolderById($id: String!, $company: String!) {
    getSharedFolderById(id: $id, company: $company) {
      _id
      name
      techpacks {
        createdAt
        createdBy {
          firstName
          lastName
        }
        techpack {
          _id
          name
          product {
            name
            code
          }
          attachments {
            link
          }
        }
      }
    }
  }
`
